import { VendorContactDTO, VendorDocumentDTO } from 'wisestep-api';

export const vendorContactPayload: VendorContactDTO = {
  id: null,
  firstName: '',
  lastName: '',
  emailAddress: '',
  phoneNumber: '',
  vendorId: '',
  position: '',
  active: true,
  statusValue: 'Active',
};

export const vendorDocumentPayload: VendorDocumentDTO = {
  id: null,
  name: '',
  s3Url: '',
  vendor: null,
  uploadedBy: '',
  uploadedOn: '',
};
